import React from 'react';
import style from './style';
import EAIcon from '../../common/EAIcon';
import moment from 'moment/moment';
import i18next from 'i18next';

const CreatedBy = ({author, creationDate}) => {
  const {classes} = style();
  return <div className={classes.root}>
    <EAIcon icon={'context/createdBy/add'}/>
    <span className={classes.addedAt}>
      {i18next.t("addedOn")} {moment(creationDate ).format("DD/MM/YYYY")}
    </span>
    <EAIcon icon={'context/createdBy/person'}/>
    <span className={classes.addedAt}>{i18next.t("by")} {author.prenom} {author.nom}</span>
  </div>
}

export default CreatedBy